<template>
	<!-- , width: fixedHeader ? `calc(100% - ${sidebarOpened ? 256 : 80}px)` : '100%'  -->
	<a-layout-header
		v-if="!headerBarFixed"
		:class="[
			fixedHeader && 'ant-header-fixedHeader',
			sidebarOpened ? 'ant-header-side-opened' : 'ant-header-side-closed',
			'rs-header',
		]"
		:style="{ padding: '0' }"
	>
		<div v-if="mode === 'sidemenu'" class="header">
			<!--<a-icon-->
			<!--v-if="device === 'mobile'"-->
			<!--class="trigger"-->
			<!--:type="collapsed ? 'menu-fold' : 'menu-unfold'"-->
			<!--@click="toggle"-->
			<!--&gt;</a-icon>-->
			<!--<a-icon-->
			<!--v-else-->
			<!--class="trigger"-->
			<!--:type="collapsed ? 'menu-unfold' : 'menu-fold'"-->
			<!--@click="toggle"-->
			<!--/>-->
			<a-icon
				class="trigger"
				:type="collapsed ? 'menu-unfold' : 'menu-fold'"
				@click="toggle"
			/>

			<user-menu></user-menu>
		</div>
		<!--<div v-else :class="['top-nav-header-index', theme]">-->
		<!--<div class="header-index-wide">-->
		<!--<div class="header-index-left">-->
		<!--<logo class="top-nav-header" :show-title="device !== 'mobile'" />-->
		<!--<s-menu-->
		<!--v-if="device !== 'mobile'"-->
		<!--mode="horizontal"-->
		<!--:menu="menus"-->
		<!--:theme="theme"-->
		<!--&gt;</s-menu>-->
		<!--<a-icon-->
		<!--v-else-->
		<!--class="trigger"-->
		<!--:type="collapsed ? 'menu-fold' : 'menu-unfold'"-->
		<!--@click="toggle"-->
		<!--&gt;</a-icon>-->
		<!--</div>-->
		<!--<user-menu class="header-index-right"></user-menu>-->
		<!--</div>-->
		<!--</div>-->
	</a-layout-header>
</template>

<script>
import UserMenu from '../tools/UserMenu'
// import SMenu from '../menu/'
// import Logo from '../tools/Logo'

import { mixin } from '@/utils/mixin'

export default {
	name: 'GlobalHeader',
	components: {
		UserMenu,
		// SMenu,
		// Logo,
	},
	mixins: [mixin],
	props: {
		mode: {
			type: String,
			// sidemenu, topmenu
			default: 'sidemenu',
		},
		menus: {
			type: Array,
			required: true,
		},
		theme: {
			type: String,
			required: false,
			default: 'dark',
		},
		collapsed: {
			type: Boolean,
			required: false,
			default: false,
		},
		device: {
			type: String,
			required: false,
			default: 'desktop',
		},
	},
	data() {
		return {
			headerBarFixed: false,
		}
	},
	mounted() {
		window.addEventListener('scroll', this.handleScroll)
	},
	methods: {
		handleScroll() {
			if (this.autoHideHeader) {
				const scrollTop =
					window.pageYOffset ||
					document.documentElement.scrollTop ||
					document.body.scrollTop
				if (scrollTop > 100) {
					this.headerBarFixed = true
				} else {
					this.headerBarFixed = false
				}
			} else {
				this.headerBarFixed = false
			}
		},
		toggle() {
			this.$emit('toggle')
		},
	},
}
</script>

<style lang="less" scoped>
.rs-header {
	z-index: 1;
	.header {
		background: #0064dc !important;
		box-shadow: 0 1px 4px 0 !important;
		i {
			color: #fff;
		}
	}
}
</style>
